import { Link } from 'react-router-dom';
import type { ReactNode } from 'react';
import type { SignatureView } from '../api/signature-view.js';
import { CodeRing } from './signature-codes.js';
import { HAND_WORDS } from './hand-words.js';

/**
 * A row for each section the server sent (the 25 October rules decide which),
 * each opening `${base}/<section>`: on the athlete's hub and inside the
 * signature on a parent's child page (stage 4b).
 *
 * With `rings`, the codes lead their rows - the motor profile, the two
 * motivations - as on a player's profile from My Team (board 13, approved 26
 * October).
 */


export function SignatureRows({ view, base, query = '', rings = false }: { view: SignatureView; base: string; query?: string; rings?: boolean }) {
  const { profile, motivations, brise } = view.sections;
  const row = (to: string, title: string, detail: string, lead: ReactNode = null) => (
    <Link className="hour-row" to={`${base}/${to}${query}`}>
      {rings && lead ? <span className="code-group-plain">{lead}</span> : null}
      <span className="hour-row-text">
        <span className="name">{title}</span>
        <span className="detail">{detail}</span>
      </span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );

  return (
    <>
      {profile?.sides[0] ? row('profile', 'Motor Profile', profile.sides[0].content.profile.name, <CodeRing code={profile.code} kind="profile" />) : null}
      {motivations.length ? row('motivations', 'Motivational Drivers', motivations.map((m) => m.content.title).join(' · '), motivations.map((m) => <CodeRing key={m.code} code={m.code} kind="motivation" />)) : null}
      {profile && view.codes.bats ? row('hitting', 'Hitting Approach', HAND_WORDS.of('bats', view.codes.bats) ?? '') : null}
      {row('brise', brise.title, brise.steps.map(([word]) => word).join(' · '))}
    </>
  );
}
